import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
  LOAD_SETTINGS:                      type('[Settings] Load Settings'),
  LOAD_SETTINGS_SUCCESS:              type('[Settings] Load Settings Success'),
  SAVE_USER_SETTINGS:                 type('[Settings] Save User Settings'),
  SAVE_FAVORITE_LOCATIONS:            type('[Settings] Save Favorite Locations'),
  FAVORITE_LOCATIONS_UPDATED:         type('[Settings] Favorite Locations Changed'),
  SUCCESS_MESSAGE_DISMISSED:          type('[Settings] Success Message Dismissed'),
};

export interface UserSettingsPayload {
  favoriteLocations?: string[];
  darkModeEnabled?: boolean;
}

export class LoadSettingsAction implements Action {
  public type = ActionTypes.LOAD_SETTINGS;
  constructor(public payload: any = '') { }
}

export class LoadSettingsSuccessAction implements Action {
  public type = ActionTypes.LOAD_SETTINGS_SUCCESS;
  constructor(public payload: UserSettingsPayload = {}) { }
}

export class SaveUserSettingsAction implements Action {
  public type = ActionTypes.SAVE_USER_SETTINGS;
  constructor(public payload: UserSettingsPayload = {}) { }
}

export class SaveFavoriteLocationsAction implements Action {
  public type = ActionTypes.SAVE_FAVORITE_LOCATIONS;
  constructor(public payload: UserSettingsPayload = {}) { }
}

export class FavoriteLocationsUpdatedAction implements Action {
  public type = ActionTypes.FAVORITE_LOCATIONS_UPDATED;
  constructor(public payload: any = '') { }
}

export class SuccessMessageDismissedAction implements Action {
  public type = ActionTypes.SUCCESS_MESSAGE_DISMISSED;
  constructor(public payload: any = '') { }
}

export type Actions
  = LoadSettingsAction
  | LoadSettingsSuccessAction
  | SaveUserSettingsAction
  | SaveFavoriteLocationsAction
  | FavoriteLocationsUpdatedAction
  | SuccessMessageDismissedAction;
